import React from "react";
import { Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import { QuestionQuery } from "../../../api/questions/typings";
import { observer } from "mobx-react-lite";
import { useMst } from "../../../mobx";

export default observer(function QuestionsFilters() {
	const { handleSubmit, control } = useForm();
	const { search } = useLocation();
	const history = useHistory();
	const { questionsStore } = useMst();
	const { getQuestions } = questionsStore;
	const params = parse(search) as QuestionQuery;

	const onSearch = async (data: any) => {
		const filters: QuestionQuery = {};
		filters["filter[number]"] = data.number ? data.number.split(",") : undefined;
		filters["filter[title]"] = data.title ? data.title : undefined;

		await getQuestions({
			...filters,
			"page[size]": "15",
			"page[number]": "1",
		});
		history.push({
			search: stringify({ ...params, ...filters, "page[number]": "1", "page[size]": "15" }),
		});
	};

	return (
		<Paper
			component={"form"}
			elevation={4}
			sx={(theme) => ({ margin: theme.spacing(2, 0), padding: theme.spacing(1, 3, 3, 3) })}
		>
			<Grid container item xs={12}>
				<Typography variant={"h6"} marginY={1}>
					Фильтр
				</Typography>
			</Grid>
			<Grid container rowGap={2}>
				<Grid container item xs={12} columnGap={2} rowGap={2}>
					<Controller
						control={control}
						render={({ field }) => <TextField {...field} label={"Номер задачи"} size={"small"} variant={"outlined"} />}
						name={"number"}
						defaultValue={params["filter[number]"] || ""}
					/>
					<Controller
						control={control}
						render={({ field }) => (
							<TextField {...field} label={"Заголовок задачи"} size={"small"} variant={"outlined"} />
						)}
						name={"title"}
						defaultValue={params["filter[title]"] || ""}
					/>
				</Grid>
				<Grid item>
					<Button size={"small"} type={"submit"} variant={"contained"} onClick={handleSubmit(onSearch)}>
						Поиск
					</Button>
				</Grid>
			</Grid>
		</Paper>
	);
});
